module.exports = __webpack_public_path__ + "static/media/noticias-favoritas.f586dc97.png";